import { render } from "./illegal.vue?vue&type=template&id=5690e547"
import script from "./illegal.vue?vue&type=script&lang=js"
export * from "./illegal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__